import React from 'react';
import { Swiper, SwiperProps } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { CommonOrganismProps } from '../../types';
import Section from '..';

interface Props extends CommonOrganismProps, Omit<SwiperProps, 'title'> {
  children: React.ReactNode;
}

export default function SectionWithSwiper({ title, children, styles, ...restProps }: Props) {
  return (
    <Section title={title} styles={`!text-center sm:!text-start h-full w-full ${styles}`}>
      <Swiper className="h-full w-full" {...restProps}>
        {children}
      </Swiper>
    </Section>
  );
}
